import {AsiDialogView} from "@asi-ngtools/lib";
import {OnInit, Component} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {
    DAYS_BEFORE_EXPIRE_KEY, IS_FIRST_CONNECTION_KEY,
    IUtilisateurWebServiceClient, MIN_PASSWORD_LENGTH, PasswordLevelValue, MAX_PASSWORD_LENGTH,
    UpdatePasswordDto
} from "../../resources/auth/resources.auth";
import {NotificationService} from "../notification/notification.service";


declare var document: any;

@Component({
    selector: 'update-password-modal-component',
    templateUrl: './update-password-modal.html',
})
export class UpdatePasswordModal extends AsiDialogView implements OnInit {

    modelForm: FormGroup;
    daysBeforeExpire: string | undefined | null;
    firstConnection: string | undefined | null;

    highLevelReg = RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[\@\[\]\^\_\!\"\#\$\%\&\'\(\)\*\+\,\-\.\/\:\;\{\}\<\>\=\|\~\?])(?=.*\d).+$/);
    middleLevelReg = RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[\@\[\]\^\_\!\"\#\$\%\&\'\(\)\*\+\,\-\.\/\:\;\{\}\<\>\=\|\~\?]).+$/);
    progressBarValue: number = 0 ;
    closable  : boolean = true;

    constructor(private fb: FormBuilder, private utilsateurService: IUtilisateurWebServiceClient, private notificationService : NotificationService) {
        super();
    }

    async ngOnInit() {
        this.daysBeforeExpire = localStorage.getItem(DAYS_BEFORE_EXPIRE_KEY);
        this.firstConnection = localStorage.getItem(IS_FIRST_CONNECTION_KEY);
        if(parseInt(this.daysBeforeExpire) == 0 || this.firstConnection == true + ''){
            this.closable = false;
        }

        this.modelForm = this.fb.group({
            ancienPwd: [null, Validators.required],
            nouveauPwd: [null, Validators.required],
            confirmationPwd: [null, Validators.required]
        });

    }

    getMaxLengthPwd(){
        return MAX_PASSWORD_LENGTH+"";
    }

    isHighLevelPasswordMatch(password: string) {
        return this.highLevelReg.test(password);
    }

    isMiddleLevelPasswordMatch(password: string) {
        return this.middleLevelReg.test(password);
    }

    isForcedAlert() {
        return this.daysBeforeExpire && parseInt(this.daysBeforeExpire) == 0;
    }

    isFirstConnection() {
        return this.firstConnection && this.firstConnection == true + '';
    }

    getProgressBarLevel(password : string){
        switch (this.load(password)){
            case null : return 0;
            case PasswordLevelValue.FAIBLE : return 33;
            case PasswordLevelValue.MOYEN : return 66;
            case PasswordLevelValue.FORT : return 100;

            default : return 0;
        }

    }

    load(password: string) {
        if (password != null && password != '' && password.length > 1) {
            // Au moins maj + min + digit + min size
            if (this.isHighLevelPasswordMatch(password)
                && password.length >= MIN_PASSWORD_LENGTH) {
                return PasswordLevelValue.FORT;
            }
            // Au moins maj + min + min size
            if (this.isMiddleLevelPasswordMatch(password)
                && password.length >= MIN_PASSWORD_LENGTH) {
                return PasswordLevelValue.MOYEN;
            }
            return PasswordLevelValue.FAIBLE;
        }
        return null;
    }


    submit(): void {
        if (!this.modelForm.valid) {
            return;
        }

        let oldPassword = this.modelForm.value.ancienPwd;
        let newPassword = this.modelForm.value.nouveauPwd;
        let confirmationPwd = this.modelForm.value.confirmationPwd;

        if(confirmationPwd  == newPassword){
            let updatePasswordDto: UpdatePasswordDto = {
                oldPassword: oldPassword,
                newPassword: newPassword
            } as UpdatePasswordDto;
            this.utilsateurService.updatepassword(updatePasswordDto).subscribe(res => {
                if(res){
                    this.notificationService.showSuccessNotification("La mise à jour du mot de passe a été effectuée avec succes.");
                    this.dialog.close();
                    window.location.reload(true);
                }else{
                    this.notificationService.showErrorNotification("Une erreur est survenue lors de la mise à jour.");
                }
            }, err => {
                this.notificationService.showErrorNotification("Une erreur est survenue lors de la mise à jour.");
            });
        }else{
            this.notificationService.showWarningNotification("Mot de passe de confirmation incorrect.");
        }

    }

    updateProgressBarLevel() {
        let nouveauPwd = this.modelForm.value.nouveauPwd;
        if(nouveauPwd){
            this.progressBarValue = this.getProgressBarLevel(nouveauPwd);
        }
    }

    isDataOk() {
        let oldPassword = this.modelForm.value.ancienPwd;
        let newPassword = this.modelForm.value.nouveauPwd;
        let confirmationPwd = this.modelForm.value.confirmationPwd;

        if(oldPassword && newPassword && confirmationPwd){
            return this.progressBarValue != 100;
        }

        return true;
    }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/update-password-modal/update-password-modal.ts